import type { InjectionKey, Ref } from 'vue';
import type { TabsRegistry } from './useTabsRegistry';

/**
 * The tab registry, provided by `TabsRoot` to its subtree. A module-level key
 * is enough: provide/inject isolates by component hierarchy, so nested/sibling
 * tab trees never collide. Type-erased to `unknown`; `T` is re-pinned by
 * `defineTabs<T>()` / `useTabs<T>()`.
 */
export const tabsRegistryKey = Symbol('nx-tabs-v2-registry') as InjectionKey<TabsRegistry<unknown>>;

/** The nearest `TabPanel`'s id, provided for descendants (e.g. sections). */
export const tabsPanelIdKey = Symbol('nx-tabs-v2-panel-id') as InjectionKey<Ref<string>>;
